import { ICON_MAP } from "./icondData";
import "./index.scss";

const Icon = ({
  iconName,
  width = 24,
  height = 24,
  className = "",
  onClick = () => {},
}) => {
  const IconComponent = ICON_MAP[iconName];

  return (
    <IconComponent 
      className={`icon ${onClick ? "icon-clickable" : ""} ${className}`}
      width={width}
      height={height}
      style={{ width: `${width}px`, height: `${height}px` }}
      onClick={onClick}
    />
  );
};

export default Icon;
